import React from "react";
// loader added to different pages
export default (props) => {
    let For = props.For !== undefined ? props.For : 'WEB-PAGE'
    let UniqueId = props.UniqueId !== undefined ? props.UniqueId : '18'
    let Height = props.Height !== undefined ? props.Height : "60vh"
    if (For === 'WEB-PAGE') {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{background: "transparent", minHeight: Height}}>
                <img src={process.env.PUBLIC_URL + `Images/Loader${UniqueId}.gif`} style={{ width:"310px", height:"310px"}} alt="LOADING.."/>
            </div>
        )
    } else {
        return (
            <div className="d-flex justify-content-center" style={{background: "transparent", minHeight: Height}}>
                <img src={process.env.PUBLIC_URL + `Images/Loader${UniqueId}.gif`} style={{ width:"310px", height:"310px"}} alt="LOADING.."/>
            </div>
        )
    }
}